<template>
  <div class="product">

    <h1>Report Tabella</h1>

      <div class="report">

        <div class="row">
            <div class="col-3">nome</div>
            <div class="col-9">{{name}}</div>
        </div>
        <div class="row">
            <div class="col-3">ean</div>
            <div class="col-9">{{ean}}</div>
        </div>
        <div class="row">
            <div class="col-3">sku</div>
            <div class="col-9">{{sku}}</div>
        </div>
        <div class="row">
            <div class="col-3">price</div>
            <div class="col-9">{{formatPrice(price)}}</div>
        </div>

      </div>

      <h3>Filtri</h3>

      <div class="filters">

        <div class="row">
            <div class="col-3">periodo</div>
            <div class="col-9">
                <select class="form-control" @change="handleChange($event)">
                    <option value="1">orario</option>
                    <option value="2">12 ore</option>
                    <option value="3">giornaliero</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-3">data da</div>
            <div class="col-9">
                <date-picker v-model="date1" :first-day-of-week="1" :lang="lang"></date-picker>
            </div>
        </div>

        <div class="row">
            <div class="col-3">data a</div>
            <div class="col-9">
                <date-picker v-model="date2" :first-day-of-week="1" :lang="lang"></date-picker>
            </div>
        </div>

        <div class="row">
            <div class="col-3">giorni</div>
            <div class="col-9">
                <input type="number" class="form-control" placeholder="Giorni" v-model="days" v-on:change="changeDays">
            </div>
        </div>

        <div class="text-center">
            <button class="app_btn" @click="getProduct">Carica</button>
        </div>

      </div>

      <div>
          <h3>Quotazioni - {{name}}</h3>
          <div class="report-table table-responsive">
              <table class="table table-striped" id="printtable">
                  <thead>
                      <tr>
                          <th>Sito</th>
                          <th v-for="timestamp in labels" v-bind:key="timestamp">{{timestamp}}</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="website in dataseries.data" v-bind:key="website" v-if="website.data[0]!=undefined && !website.hidereport" v-show="!diswebsites.includes(website.name)">
                          <td>{{website.name}}</td>
                          <td v-for="row in website.data" v-bind:key="row">
                              <span v-bind:class="{ red: row.isLowest }">{{formatPrice(row.price)}}</span>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div>
              <span v-for="website in dataseries.data" v-bind:key="website" v-if="website.data[0]!=undefined && !website.hidereport"><a @click="disSite(website.name)" style="margin:10px;" v-bind:class="{ disabled: diswebsites.includes(website.name) }">{{website.name}}</a></span>
          </div>
      </div>

      <div>
          <a v-on:click="printPDF()" class="app_btn d-block text-center mx-auto">Stampa PDF</a>
          <router-link v-bind:to="{ name: 'ReportProductSku', params: { sku: sku } }" class="app_btn d-block text-center mx-auto">Grafico</router-link>
          <router-link v-bind:to="{ name: 'ReportProducts' }" class="app_btn d-block text-center mx-auto">Torna alla lista</router-link>
      </div>

  </div>
</template>

<script>
import printJS from 'print-js'
import DatePicker from 'vue2-datepicker'
import ProductsService from '@/services/ProductsService'
import LineChart from './LineChart.js'
import moment from 'moment'
export default {
  name: 'ReportProductTable',
  components: { LineChart, DatePicker },
  data () {
    return {
        lang: 'it',
        period: 1,
        date1: moment().subtract(3, 'days'),
        date2: new Date(),
        // date2: new Date(),
        days: 3,
        name: '',
        ean: '',
        sku: '',
        price: 0,
        websites: {},
        websitesmap: [],
        diswebsites: [],
        labels: [],
        dataseries: null,
        datacollection: null
    }
  },
  mounted () {
      this.getProduct()
      // $('[data-toggle="tooltip"]').tooltip()
  },
  methods: {
    fillData () {
        // var labels = []
        /* var maxseries = 0
        var maxcount = 0
        for (var i in this.dataseries) {
            if (this.dataseries[i].data.length > maxcount) {
                maxcount = this.dataseries[i].data
                maxseries = i
            }
        } */
        this.labels = []
        for (var item of this.dataseries.periods) {
            // if (item.price > 0) {
                this.labels.push(this.formatDateTime(item))
            // }
        }
        for (var j in this.dataseries.data) {
            for (var k in this.dataseries.data[j].data) {
                this.dataseries.data[j].data[k].isLowest = this.isLowest(this.dataseries.data[j].data[k].price, k) && this.dataseries.data[j].data[k].price > 1
            }
        }
        console.log(this.dataseries.data)
    },
    disSite (website) {
        function arrayRemove (arr, value) {
           return arr.filter(function (ele) {
               return ele !== value
           })
        }
        if (this.diswebsites.includes(website)) {
            this.diswebsites = arrayRemove(this.diswebsites, website)
        } else {
            this.diswebsites.push(website)
        }
    },
    printPDF () {
        printJS({printable: 'printtable', type: 'html', documentTitle: this.name})
    },
    changeDays () {
        if (this.days > 0) {
            this.date1 = moment().subtract(this.days, 'days')
        }
    },
    getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    async getProduct () {
      const response = await ProductsService.reportsku({
        sku: this.$route.params.sku
      })
      // console.log(response.data)
      this.name = response.data.name
      this.ean = response.data.ean
      this.sku = response.data.sku
      this.price = response.data.price
      this.websites = response.data.websites

      const response2 = await ProductsService.reportseries({
        sku: this.$route.params.sku,
        period: this.period,
        date1: Math.floor(new Date(this.date1) * 1),
        date2: Math.floor(new Date(this.date2) * 1)
      })
      this.dataseries = response2.data
      this.fillData()
    },
    handleChange (event) {
        this.period = event.target.value
    },
    isLowest (price, n) {
        for (var i in this.dataseries.data) {
            if (this.dataseries.data[i].hidereport !== true && this.dataseries.data[i].data[n] && this.dataseries.data[i].data[n].price > 1 && this.dataseries.data[i].data[n].price < price) {
                return false
            }
        }
        return true
    },
    formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate (value) {
        var date = new Date(value)
        return date.toLocaleDateString()
    },
    formatDateTime (value) {
        var date = new Date(value)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  }
}
</script>
<style type="text/css">
.report {
  margin-bottom: 20px;
}
.report div, .filters div {
  text-align: left;
}
.table-data {
  margin-bottom: 20px;
}
.table-data div {
  text-align: left;
}
.filters .row {
    margin-bottom: 10px;
}
.mx-datepicker {
  width: 100%!important;
}
.app_btn, .app_btn:link, .app_btn:hover {
  margin: 20px 0;
  background: #4d7ef7;
  color: #fff!important;
  padding: 10px 80px;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
.fotocolombo, .fotocolombo-acquisto, .fotocolombo-bundle {
    color:#E74C3C!important;
}
.filters .row {
    margin-bottom: 10px;
}
.report-table table tr td {
    color: #212529!important;
}
.report-table table td {
    padding: 6px;
}
.report-table table {
    font-size: .725rem;
}
.red {
    color: red;
    font-weight: bold;
}
.disabled {
    text-decoration: line-through!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportProductTable.vue